// extracted by mini-css-extract-plugin
module.exports = {"homeSliderButtons":"home_homeSliderButtons__3b50v"};